import type { NcrRecord } from '@/modules/ncr/NcrClient';

export interface NcrModalController {
  create: () => void;
  edit: (record: NcrRecord | string) => void | Promise<void>;
  openDeepLink: (id: string) => Promise<void>;
  updateRecord: (record: NcrRecord) => void;
  reset: () => void;
}

declare global {
  interface Window {
    NcrModalController?: NcrModalController;
  }
}

export function registerNcrModalController(controller: NcrModalController): void {
  window.NcrModalController = controller;
  window.dispatchEvent(new CustomEvent('jidoka:ncr-modal-ready'));
}
